import axios from "axios";
import i18n from "i18next";
import {
    INCENTIVE_CAMPAIGNS,
    INCENTIVE_DASHBOARD,
    INCENTIVE_LEDGER,
    INCENTIVE_NOTIFICATIONS,
    INCENTIVE_OPPORTUNITIES,
    INCENTIVE_REVIEW_QUEUE,
    INCENTIVE_REWARD_STATUS,
    WALLET_COIN_PURCHASES,
    WALLET_COIN_QUOTE,
    WALLET_COIN_VERIFY,
    WALLET_SUMMARY,
    incentiveCampaignUrl,
    incentiveReviewUrl,
} from "../../helperData/ApiAddress";

const headers = () => ({
    Authorization: sessionStorage.getItem("auth")
        ? `Bearer ${sessionStorage.getItem("auth")}`
        : undefined,
    "Accept-Language": i18n.language || "fa",
});

const unwrapRows = (data) =>
    Array.isArray(data) ? data : data?.results || data?.items || [];

export const incentivesApi = {
    dashboard: () =>
        Promise.all([
            axios.get(INCENTIVE_DASHBOARD, { headers: headers() }),
            axios.get(WALLET_SUMMARY, { headers: headers() }),
        ]).then(([dashboard, wallet]) => ({
            ...dashboard.data,
            wallet: wallet.data,
        })),
    campaigns: (params) =>
        axios
            .get(INCENTIVE_CAMPAIGNS, { headers: headers(), params })
            .then((r) => ({ rows: unwrapRows(r.data), count: r.data?.count })),
    createCampaign: (data) =>
        axios
            .post(INCENTIVE_CAMPAIGNS, data, { headers: headers() })
            .then((r) => r.data),
    campaign: (id) =>
        axios
            .get(incentiveCampaignUrl(id), { headers: headers() })
            .then((r) => r.data),
    updateCampaign: (id, data) =>
        axios
            .patch(incentiveCampaignUrl(id), data, { headers: headers() })
            .then((r) => r.data),
    deleteCampaign: (id) =>
        axios.delete(incentiveCampaignUrl(id), { headers: headers() }),
    publishCampaign: (id) =>
        axios
            .post(incentiveCampaignUrl(id, "publish"), {}, { headers: headers() })
            .then((r) => r.data),
    reviews: (params) =>
        axios
            .get(INCENTIVE_REVIEW_QUEUE, { headers: headers(), params })
            .then((r) => ({ rows: unwrapRows(r.data), count: r.data?.count })),
    decideReview: (id, decision, note) =>
        axios
            .post(
                incentiveReviewUrl(id, decision),
                { note },
                { headers: headers() }
            )
            .then((r) => r.data),
    ledger: (params) =>
        axios
            .get(INCENTIVE_LEDGER, { headers: headers(), params })
            .then((r) => ({ rows: unwrapRows(r.data), count: r.data?.count })),
    quoteCoins: (quantity) =>
        axios
            .post(WALLET_COIN_QUOTE, { quantity }, { headers: headers() })
            .then((r) => r.data),
    purchaseCoins: (data) =>
        axios
            .post(WALLET_COIN_PURCHASES, data, { headers: headers() })
            .then((r) => r.data),
    verifyPurchase: (authority) =>
        axios
            .post(WALLET_COIN_VERIFY, { authority }, { headers: headers() })
            .then((r) => r.data),
    createQuickCampaign: (data) =>
        axios
            .post(INCENTIVE_CAMPAIGNS, data, { headers: headers() })
            .then((r) => r.data),
    opportunity: (params) =>
        axios
            .get(INCENTIVE_OPPORTUNITIES, { headers: headers(), params })
            .then((r) => r.data),
    rewardStatus: (params) =>
        axios
            .get(INCENTIVE_REWARD_STATUS, { headers: headers(), params })
            .then((r) => r.data),
    notifications: () =>
        axios
            .get(INCENTIVE_NOTIFICATIONS, { headers: headers() })
            .then((r) => unwrapRows(r.data)),
    markNotificationRead: (id) =>
        axios.post(
            `${INCENTIVE_NOTIFICATIONS}${id}/read/`,
            {},
            { headers: headers() }
        ),
};

export const errorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (!data) return fallback;
    if (typeof data.detail === "string") return data.detail;
    if (typeof data.message === "string") return data.message;
    const nested = Object.values(data).flat?.()[0];
    if (typeof nested === "string") return nested;
    if (typeof data.code === "string") return data.code;
    return fallback;
};
